module.exports = __webpack_public_path__ + "static/media/crocodile(28).bd09aea4.PNG";